import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import { validateGlossarySearch, glossaryJsonLd } from "@/lib/glossary-page";
import { WoordenlijstPage } from "@/pages/woordenlijst";

const TITLE = "Woordenlijst — alle vaktermen uitgelegd | IT Solutions";
const DESC =
  "Van Smart Routing tot headless CMS: alle technische termen van onze pakketten in klare taal uitgelegd, met concrete voorbeelden.";

export const Route = createFileRoute("/woordenlijst/")({
  validateSearch: validateGlossarySearch,
  head: () =>
    pageHead({
      lang: "nl",
      pathWithoutLang: "/woordenlijst",
      title: TITLE,
      description: DESC,
      jsonLd: glossaryJsonLd("nl"),
    }),
  component: WoordenlijstPage,
});
